import PropTypes from 'prop-types';
import cn from 'classnames';

import { getMentionLabel, parseMentionText } from 'utlis/chatPrototype';

import styles from './styles.module.scss';

// A sent message, with "#id (title)" of a known new idea shown as the same finding button as in the input
export function UserMessageContent({ content, mentionOptions }) {
  return (
    <span>
      {parseMentionText(content, mentionOptions).map((segment, index) => (
        segment.type === 'mention'
          ? (
            <span
              key={index}
              className={cn(styles['feedback-reference-button'], styles['user-message-chip'])}
            >
              {getMentionLabel(segment.option)}
            </span>
          )
          : segment.value
      ))}
    </span>
  );
}

UserMessageContent.propTypes = {
  content: PropTypes.string,
  mentionOptions: PropTypes.array,
};

UserMessageContent.defaultProps = {
  content: '',
  mentionOptions: [],
};
